'use strict';

/**
 * PDP Color Swatch Tooltip
 */
module.exports = {
    init: function () {
        var $swatch = $('.attributes .swatch-circle[data-toggle="tooltip"]');
        var $swatchButton = $swatch.closest('button.color-attribute');
        var tooltipOptions = {
            container: '.attributes',
            html: true,
            offset: '0, 20px',
            trigger: 'manual',
            animation: false,
            template: '<div class="tooltip swatch-tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>'
        };
        var showSwatchTooltip = function ($currentSwatch) {
            $swatch.not($currentSwatch).tooltip('hide');
            $currentSwatch.tooltip('show');
        };

        $swatch.tooltip('dispose').tooltip(tooltipOptions);
        $swatch.off('.swatchTooltip')
            .on('mouseenter.swatchTooltip', function () {
                showSwatchTooltip($(this));
            })
            .on('mouseleave.swatchTooltip', function () {
                $(this).tooltip('hide');
            });
        $swatchButton.off('.swatchTooltip')
            .on('focusin.swatchTooltip', function () {
                showSwatchTooltip($(this).find('.swatch-circle[data-toggle="tooltip"]'));
            })
            .on('focusout.swatchTooltip', function () {
                $(this).find('.swatch-circle[data-toggle="tooltip"]').tooltip('hide');
            });
    }
};
